import { render } from "./FileViewer.vue?vue&type=template&id=7d064f2a"
import script from "./FileViewer.vue?vue&type=script&lang=js"
export * from "./FileViewer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\PHPRad Projects\\uplbmv2\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__